module.exports = __webpack_public_path__ + "img/img4.13dfd43e.jpg";